import styled, { css } from 'styled-components';
import { assertBKJThemeType } from '../../index.js';
import { InputErrorMessageCSS, InputLabelCSS, InputRequiredAsteriskCSS } from '../common/index.js';
import { BKJTextInputBaseCSS } from './BKJTextInput.css.styled.js';
export const BKJTextInputWrapper = styled.label `
  ${(props) => assertBKJThemeType('BKJTextInput', props)};
  ${({ theme, variant = 'RoundEdges' }) => theme.textInput[variant]};
  display: flex;
  position: relative;
  align-items: center;
  box-shadow: none;
`;
export const BKJTextInputTextInput = styled.input `
  ${BKJTextInputBaseCSS};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: text;
  &:focus {
    outline: none;
  }
  ${({ theme, variant = 'RoundEdges' }) => theme.textInput[variant]};
  ${({ hasLeftIcon }) => hasLeftIcon &&
    css `
      &&& {
        padding-left: 38px !important;
      }
    `};
  ${({ hasRightIcon }) => hasRightIcon &&
    css `
      &&& {
        padding-right: 32px !important;
      }
    `};
`;
export const BKJTextInputIconWrapper = styled.div `
  width: fit-content;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 150ms ease-in-out;
  transform: scale(1, 1);
  ${({ padding }) => padding &&
    css `
      padding: ${padding};
    `};
  ${({ isOpen }) => isOpen &&
    css `
      transform: scale(1, -1);
    `};
`;
export const BKJTextInputLabel = styled.label `
  ${({ theme, variant = 'RoundEdges' }) => theme.textInput[variant]};
  ${InputLabelCSS};
`;
export const BKJTextInputRequiredAsterisk = styled.label `
  ${InputLabelCSS};
  ${InputRequiredAsteriskCSS};
`;
export const BKJTextInputFieldSet = styled.fieldset `
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
`;
export const BKJTextInputDescription = styled.div ``;
export const BKJTextInputErrorMessage = styled.pre `
  ${InputErrorMessageCSS};
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
//# sourceMappingURL=BKJTextInput.styled.js.map